var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch",class:{active: _vm.value},on:{"click":function($event){return _vm.update()}}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }